<nz-alert
  nzType="warning"
  [nzMessage]="
    'LOT_INFO.TRADING_TIME_SHIFT.WARNING'
      | translate
        : {
            direction: (directionKey | translate),
            time: formattedShiftTime
          }
  "
></nz-alert>
